module.exports = __webpack_public_path__ + "img/1-2.35e09e52.jpg";